// eslint-disable-next-line
import { BasicLayout } from '@/layouts'
// import { bxAnaalyse } from '@/core/icons'

const RouteView = {
  name: 'RouteView',
  render: h => h('router-view')
}

/**
 * 运营中心路由
 */
export const manageRouterMap = [
  {
    path: '/',
    name: 'index',
    component: BasicLayout,
    meta: { title: '首页' },
    redirect: '/manage/home',
    children: [
      {
        path: '/manage/home',
        name: 'Home',
        component: () => import('@/views/home/index'),
        meta: { title: '欢迎页面', icon: 'home', keepAlive: true, permission: ['dashboard'] }
      },
      {
        path: '/manage/card',
        name: 'Card',
        component: () => import('@/views/manage/card/index'),
        meta: { title: '服务卡', icon: 'credit-card', keepAlive: true, permission: ['dashboard'] },
        hideChildrenInMenu: true,
            children: [
              {
                path: '/manage/card/detail',
                name: 'CardDetail',
                component: () => import('@/views/manage/card/detail'),
                meta: { title: '服务卡信息详情', keepAlive: true, permission: ['form'] }
              }
            ]
      },
      {
        path: '/manage/prepay',
        name: 'PrePay',
        component: () => import('@/views/manage/prepay/index'),
        meta: { title: '消费合约', icon: 'account-book', keepAlive: true, permission: ['dashboard'] },
        hideChildrenInMenu: true,
            children: [
              {
                path: '/manage/prepay/detail',
                name: 'PrePayDetail',
                component: () => import('@/views/manage/prepay/PrePayDetail'),
                meta: { title: '消费合约详情', keepAlive: true, permission: ['form'] }
              }
            ]
      },
      {
        path: '/manage/pay',
        name: 'Pay',
        component: () => import('@/views/manage/pay/index'),
        meta: { title: '付款计划', icon: 'transaction', keepAlive: true, permission: ['dashboard'] },
        hideChildrenInMenu: true,
            children: [
              {
                path: '/manage/pay/detail',
                name: 'PayDetail',
                component: () => import('@/views/manage/pay/detail'),
                meta: { title: '付款计划详情', keepAlive: true, permission: ['form'] }
              }
            ]
      },
      {
        path: '/manage/payment',
        name: 'Payment',
        component: () => import('@/views/manage/payment/index'),
        meta: { title: '付款单', icon: 'pay-circle', keepAlive: true, permission: ['dashboard'] },
        hideChildrenInMenu: true,
            children: [
              {
                path: '/manage/payment/detail',
                name: 'PaymentDetail',
                component: () => import('@/views/manage/payment/detail'),
                meta: { title: '付款单详情', keepAlive: true, permission: ['form'] }
              }
            ]
      },
      {
        path: '/manage/userSearch',
        name: 'UserSearch',
        component: () => import('@/views/manage/userSearch/index'),
        meta: { title: '用户搜索', icon: 'solution', keepAlive: true, permission: ['dashboard'] },
        hideChildrenInMenu: true,
            children: [
              {
                path: '/manage/userSearch/Detail',
                name: 'UserDetail',
                component: () => import('@/views/manage/userSearch/Detail'),
                meta: { title: '用户信息详情', keepAlive: true, permission: ['form'] }
              }
            ]
      },
      {
        path: '/manage/person',
        component: RouteView,
        redirect: '/manage/person/center',
        name: 'person',
        meta: { title: '客户档案', icon: 'user', keepAlive: true, permission: ['user'] },
        children: [
          {
            path: '/manage/center',
            name: 'center',
            component: () => import('@/views/manage/person/center'),
            meta: { title: '个人中心', keepAlive: true, permission: ['user'] }
          },
          {
            path: '/manage/settings',
            name: 'settings',
            component: () => import('@/views/manage/person/settings/Index'),
            meta: { title: '个人设置', hideHeader: true, permission: ['user'] },
            redirect: '/manage/person/settings/basic',
            hideChildrenInMenu: true,
            children: [
              {
                path: '/manage/person/settings/basic',
                name: 'BasicSettings',
                component: () => import('@/views/manage/person/settings/BasicSetting'),
                meta: { title: '基本设置', hidden: true, permission: ['user'] }
              },
              {
                path: '/manage/person/settings/security',
                name: 'SecuritySettings',
                component: () => import('@/views/manage/person/settings/Security'),
                meta: {
                  title: '安全设置',
                  hidden: true,
                  keepAlive: true,
                  permission: ['user']
                }
              },
              // {
              //   path: '/person/settings/custom',
              //   name: 'CustomSettings',
              //   component: () => import('@/views/manage/person/settings/Custom'),
              //   meta: { title: '个性化', hidden: true, keepAlive: true, permission: ['user'] }
              // },
              {
                path: '/manage/person/settings/binding',
                name: 'BindingSettings',
                component: () => import('@/views/manage/person/settings/Binding'),
                meta: { title: '账号绑定', hidden: true, keepAlive: true, permission: ['user'] }
              },
              {
                path: '/manage/person/settings/notification',
                name: 'NotificationSettings',
                component: () => import('@/views/manage/person/settings/Notification'),
                meta: {
                  title: '新消息通知',
                  hidden: true,
                  keepAlive: true,
                  permission: ['user']
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]
